import { Expose } from "class-transformer";

export class UnassignPlanningBoardLoanVehicleDto {
  @Expose()
  vehicleId: string;
}
